import IntroContent from '../content/introduction/IntroSections';
import { useStrings } from '../locales';
import './Introduction.css';

export default function Introduction() {
  const s = useStrings().introduction;

  return (
    <div className="page-centered">
      <div className="page-header">
        <h1>{s.title}</h1>
        <p>{s.desc}</p>
      </div>

      <IntroContent />
    </div>
  );
}
